import { createContext } from 'react';

export type Tenant = {
    id: string;
    name: string;
    webshopUrl: string | undefined;
};

export const TenantContext = createContext<Tenant | undefined>(undefined);
